<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          General Item / Inventories &nbsp;
          <add-button
            link="/planned-maintenance/general-item-inventories/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">General Item / Inventories</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportgeneral_item_inventories.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="general_item_inventories_excel"
                    :fields="excel_fields"
                    worksheet="General Item / Inventories"
                    name="General Item / Inventory.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel</th>
                    <th>Category</th>
                    <th>Item Name</th>
                    <th>Part Number</th>
                    <th>Draw Number</th>
                    <th>Location On Board</th>
                    <th>ROB</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="general_item_inventories.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(
                      general_item_inventory, at
                    ) in general_item_inventories"
                    :key="`general_item_inventory${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ general_item_inventory.vessel.name }}</td>
                    <td>{{ general_item_inventory.category.name }}</td>
                    <td>{{ general_item_inventory.item_name }}</td>
                    <td>{{ general_item_inventory.part_number }}</td>
                    <td>{{ general_item_inventory.draw_number}}</td>
                    <td>{{ general_item_inventory.location_on_board.name }}</td>
                    <td>{{ general_item_inventory.rob }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/general-item-inventories/${general_item_inventory.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(general_item_inventory.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "general_item_inventory",
  data() {
    return {
      general_item_inventories: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      general_item_inventories_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Vessel: "vessel",
        Category: "category_id",
        "Item Name": "item_name",
        "Item Code": "item_code",
        "SFI Code": "sfi_code",
        Make: "make",
        "Part Number": "part_number",
        "Draw Number": "draw_number",
        "Model Number": "model_number",
        "Serial Number": "serial_number",
        Measure: "measure_id",
        "Expiry Date": "expiry_date",
        "Location on Board": "location_on_board",
        "Is Critical": "is_critical",
        "Is SOPEP Item": "is_sopep_item",
        Remarks: "remarks",
        Attchment: "attachment",
        "Average Price": "average_price",
        "Latest Price": "latest_price",
        "Current Total Price": "current_total_price",
        "Supplier Name": "supplier_name",
        "PO Number": "po_number",
        "Min Alarm Level": "min_alarm_level",
        "Max Alarm Level": "max_alarm_level",
        "Consumed Quality": "consumed_quantity",
        ROB: "rob",
        "New Items": "new_items",
        "Is Tracked Item": "is_tracked_item",
      },
      Exportgeneral_item_inventories: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let general_item_inventories = await axios.get(
        `/general_item_inventories?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.general_item_inventories = general_item_inventories.data.data;
      this.count = general_item_inventories.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let general_item_inventories = await axios.get(
        `/general_item_inventories?search=${this.searchData}`
      );
      this.general_item_inventories = general_item_inventories.data.data;
      this.count = general_item_inventories.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "General Item / Inventory Data";
      this.general_item_inventories_excel = [];
      let Exportgeneral_item_inventories = [];
      Exportgeneral_item_inventories = await axios.get(
        `/general_item_inventories`
      );
      this.Exportgeneral_item_inventories =
        Exportgeneral_item_inventories.data.data;
      let sr_no = 1;
      this.Exportgeneral_item_inventories.forEach((general_item_inventory) => {
        this.general_item_inventories_excel.push({
          sr_no: sr_no,
          vessel: general_item_inventory.vessel.name
            ? general_item_inventory.vessel.name
            : "",
          item_name: general_item_inventory.item_name
            ? general_item_inventory.item_name
            : "",
          item_code: general_item_inventory.item_code
            ? general_item_inventory.item_code
            : "",
          sfi_code: general_item_inventory.sfi_code
            ? general_item_inventory.sfi_code
            : "",
          make: general_item_inventory.make
            ? general_item_inventory.make
            : "",
          part_number: general_item_inventory.part_number
            ? general_item_inventory.part_number
            : "",
          draw_number: general_item_inventory.draw_number
            ? general_item_inventory.draw_number
            : "",
          model_number: general_item_inventory.model_number
            ? general_item_inventory.model_number
            : "",
          serial_number: general_item_inventory.serial_number
            ? general_item_inventory.serial_number
            : "",
          measure_id: general_item_inventory.measure_id
            ? general_item_inventory.measure_id
            : "",
          expiry_date: general_item_inventory.expiry_date
            ? general_item_inventory.expiry_date
            : "",
          location_on_board: general_item_inventory.location_on_board.name
            ? general_item_inventory.location_on_board.name
            : "",
          is_critical: general_item_inventory.is_critical
            ? general_item_inventory.is_critical == true ? 'Yes': 'No'
            : "",
          is_sopep_item: general_item_inventory.is_sopep_item
            ? general_item_inventory.is_sopep_item == true ? 'Yes': 'No'
            : "",
          remarks: general_item_inventory.remarks
            ? general_item_inventory.remarks
            : "",
          attachment: general_item_inventory.attachment
            ? general_item_inventory.attachment
            : "",
          average_price: general_item_inventory.average_price
            ? general_item_inventory.average_price
            : "",
          latest_price: general_item_inventory.latest_price
            ? general_item_inventory.latest_price
            : "",
          current_total_price: general_item_inventory.current_total_price
            ? general_item_inventory.current_total_price
            : "",
          supplier_name: general_item_inventory.supplier_name
            ? general_item_inventory.supplier_name
            : "",
          po_number: general_item_inventory.po_number
            ? general_item_inventory.po_number
            : "",
          min_alarm_level: general_item_inventory.min_alarm_level
            ? general_item_inventory.min_alarm_level
            : "",
          max_alarm_level: general_item_inventory.max_alarm_level
            ? general_item_inventory.max_alarm_level
            : "",
          consumed_quantity: general_item_inventory.consumed_quantity
            ? general_item_inventory.consumed_quantity
            : "",
          rob: general_item_inventory.rob
            ? general_item_inventory.rob
            : "",
          new_items: general_item_inventory.new_items
            ? general_item_inventory.new_items
            : "",
          is_tracked_item: general_item_inventory.is_tracked_item
            ? general_item_inventory.is_tracked_item == true ? 'Yes': 'No'
            : "",
          category: general_item_inventory.category.name
            ? general_item_inventory.category.name
            : "",
          measure: general_item_inventory.measure.name
            ? general_item_inventory.measure.name
            : "",
          
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=general_item_inventories`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
